import React from "react";
import { Card, Columns } from "react-bulma-components";
import { Icon } from "../common/Icon";
import { UilImageUpload } from "@iconscout/react-unicons";
import Dropzone from "react-dropzone";
import ProjectSection from "./ProjectSection";
import Lightbox from "../common/Lightbox";

export default function ProjectPhotos({ photos, onDropFiles, onTriggerDelete, onTriggerModal, project }) {
    return (
        <ProjectSection title="Photos" itemCount={ photos.length } noItemsText="No photos yet!" alwaysShowChildren>
            <Columns>
                <Lightbox images={ photos } renderChild={
                    (photo, onClick) => (
                        <Columns.Column key={ photo.id } size={ 3 }>
                            <Card>
                                <div className="card-image">
                                    <a className="image" onClick={ onClick }>
                                        <img src={ photo.size_256 } alt={ photo.caption }/>
                                    </a>
                                </div>
                            </Card>
                        </Columns.Column>
                    )
                }/>
            </Columns>

            <Dropzone onDrop={ files => onDropFiles('photos', files) }>
                { ({ getRootProps, getInputProps }) => (
                    <section className="dropzone my-5">
                        <div { ...getRootProps() }>
                            <input { ...getInputProps() } />

                            <div className="is-size-6">
                                <Icon icon={ UilImageUpload } size={ 48 }/>
                            </div>

                            Drop photos here, or click to upload.
                        </div>
                    </section>
                ) }
            </Dropzone>
        </ProjectSection>
    );
}